var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmojiHover = function SvgEmojiHover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FD7",
    stroke: "#FC9702"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD9702",
    d: "M26.786 18.089c-1.413 5.335-6.15 9.258-11.776 9.258-5.652 0-10.407-3.301-11.796-9.014.255-4.473 5.438-3.15 11.796-3.15 6.238 0 11.347-1.274 11.776 2.906z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FD9702",
    transform: "translate(5.286 8.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.018,
    cy: 2.5,
    r: 2.143
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.825,
    cy: 2.5,
    r: 2.143
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmojiHover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emoji-hover.b6c8c54ad6bddaf1fe5bf596f14b2eb5.svg";